module.exports = __webpack_public_path__ + "img/img_size7_test.64b33aa2.png";